export function confirmActionState(
  busy: boolean,
  missingRequiredValue: boolean,
): { disabled: boolean; loading: boolean } {
  return {
    disabled: !busy && missingRequiredValue,
    loading: busy,
  };
}
